import { NgModule } from '@angular/core';
import { CreditUsageComponent } from './credit-usage/credit-usage.component';
import { CommonModule } from '@angular/common';
import { ChartsModule } from 'ng2-charts';
import { UserListComponent } from './user-list/user-list.component';
import { DeleteUserComponent } from './delete-user/delete-user.component';
import { AddUserComponent } from './add-user/add-user.component';
import { TranslateModule } from 'ng2-translate';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { EditCompanyComponent } from './edit-company/edit-company.component';


@NgModule({
  imports: [
    CommonModule,
    ChartsModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  declarations: [
    CreditUsageComponent,
    UserListComponent,
    AddUserComponent,
    DeleteUserComponent,
    EditCompanyComponent
  ],
  exports: [
    CreditUsageComponent,
    UserListComponent
  ],
  entryComponents: [
    AddUserComponent,
    DeleteUserComponent,
    EditCompanyComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/modules/admin/shared/shared.module.ts